
import React, { useEffect, useRef, useState } from 'react';

import { useRecoilState } from 'recoil';
import { isChildOpenAtom, isFolderOpenAtom, isFrostyAtom, openAppAtom } from '../recoil/isChildOpenAtom';

import {
    motion,
    //useMotionValue
} from "framer-motion";

//import Phone from './apps/Phone';
import Camera from './apps/Camera';
import Settings from './apps/Settings';
import Twitter from './apps/Twitter';
import About from './apps/About';
import Work from './apps/Work';
import Blog from './apps/Blog';
import { useHistory } from "react-router-dom";

import Badge from './Badge';

import './Folder.css';

const animateSpeedSeconds = 0.24;

const Folder = ({ name, children, badge }) => {

  console.log('Folder render');
  
  //let history = useHistory();
  const [isThisFolderOpen, setIsThisFolderOpen] = useState(false);
  const [isFolderOpen, setIsFolderOpen] = useRecoilState(isFolderOpenAtom);
  const [isChildOpen, setIsChildOpen] = useRecoilState(isChildOpenAtom);
  //const [openApp, setOpenApp] = useRecoilState(openAppAtom);
  
  // const apps = [
  //   'Camera',
  //   'Settings',
  //   //'Phone',
  //   'Twitter',
  //   'About',
  //   'Work',
  //   'Blog',
  // ];

  // const closeApp = (e) => {
  //     e.preventDefault();
  //     setIsChildOpen(false);
  //     //setIsFrosty(false);

  //     // Make the icon show back up
  //     setTimeout(() => {
  //     const openAppEl = document.querySelector('.app-item[data-isopen=true]');
  //     if (openAppEl) {
  //         openAppEl.removeAttribute('data-isopen');
  //     }
  //     }, animateSpeedSeconds * 1000);

  //     const pageEl = document.querySelector(`.page[data-isopen=true]`);
  //     if (pageEl) {
  //     pageEl.removeAttribute('data-isopen');
  //     }

  //     history.push('/');
  // };

  const onClick = () => {
    if (!isThisFolderOpen) {
      setIsThisFolderOpen(curr => !curr);
      setIsFolderOpen(curr => !curr);
    }

  };

  const onClickFrosty = () => {
    if (isThisFolderOpen) {
      setIsThisFolderOpen(false);
      setIsFolderOpen(false);
    }
  };

  return (
    <div className="folder-item-area" onClick={onClick}>
      <div
        className={isThisFolderOpen ? 'folder-frosty frosty selected' : 'folder-frosty frosty'}
        onClick={onClickFrosty}
      />
      <motion.div
        layout
        className={'folder-item backdrop-blur'}
        data-isclosed={!isThisFolderOpen}
        transition={{
          //type: "spring",
          //stiffness: 100,
          //type: 'tween',
          ease: 'easeOut',
          duration: animateSpeedSeconds,
        }} 
      >
       
        {(badge && !isThisFolderOpen) && <Badge badge={badge} />}

        <div className="folder-grid-area">
          <div className="folder-grid">
            {children}
          </div>
        </div>


        <div className="folder-item-top-text">{name}</div>
        <div className="folder-item-text">{name}</div>
      </motion.div>
      
    </div>
  );
   
 }
 
 export default Folder;
 